<template>
  <div class="report-referred-request">

    <v-row class="report-date-picker">
      <div class="col-6">
        <label class="from">{{ $t('fromDate') }}</label>
        <date-picker v-model="start_date"></date-picker>
      </div>
      <div class="col-6">
        <label class="to">{{ $t('toDate') }}</label>
        <date-picker v-model="end_date"></date-picker>
      </div>
    </v-row>
    <v-row class="report-date-picker">
      <v-col cols="12">
        <v-text-field
          placeholder="جستجو"
          v-model="search_list"
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <div>
      <!--        <v-row-->
      <!--          v-for="(item, i) in request_items"-->
      <!--          :key="i"-->
      <!--          cols="12"-->
      <!--        >-->
      <!--          <v-col cols="12">-->
      <div class="req-card white m-1" style="padding: 2px;margin: 2px"
            v-for="item in request_items_filtered"
           :key="item.Id">
        <div>
          <div class="row ">
            <div class="col-12">
              <div
                class="req-name"
                v-text="item.ProductName"
              ></div>
            </div>
            <div class="col-4">
              <div
                   class="req-name"
                   v-text="item.Qty+' عدد '"
              ></div>

            </div>
            <div class="col-4">
              <div
                   class="req-name"
                   v-text="item.SourceBranchName"
              ></div>

            </div>
            <div class="col-4">
              <div
                   class="req-name"
                   v-text="item.TechName"
              ></div>

            </div>

          </div>

        </div>

      </div>

      <!--          </v-col>-->
      <!--        </v-row>-->
      <vue-context ref="menu">
        <li>
          <a href="#" @click.prevent="">{{ $t('receiveSignature') }}</a>
        </li>
        <li>
          <a href="#" @click.prevent="context_menu_clicked('payments')">{{ $t('allPays') }}</a>
        </li>
      </vue-context>
    </div>

  </div>

</template>
<script>
  import Vue from 'vue'
  import moment from 'moment-jalaali'

  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
  import VueContext from 'vue-context'
  import 'vue-context/src/sass/vue-context.scss'

  Vue.component('date-picker', VuePersianDatetimePicker)
  export default {
    props:[
      'passing_data'
    ],
    data () {
      return {
        search_list: "",

        errors: [],
        start_date: '',
        end_date: '',
        request_items:[],
        request_items_filtered:[],
        clicked_request_context:null,
      }
    },
    components:{
      datePicker: VuePersianDatetimePicker,
      VueContext,
    },
    watch: {
      search_list: function() {
        var self = this;
        // console.log("search changed",this.search_list)
        self.request_items_filtered = [];
        if (self.search_list == "") {
          this.request_items_filtered = this.request_items;
        } else {
          this.request_items_filtered = [];
          this.request_items.forEach(function (val) {
            if (val.ProductName.includes(self.search_list) || val.TechName.includes(self.search_list)) {
              self.request_items_filtered.push(val)
            }
          })
        }
      },
      start_date: function () {
        this.get_report(0)
      },
      end_date: function () {
        this.get_report(0)
      },

    },
    mounted () {
      this.start_date = moment().utc().format('jYYYY/jMM/jDD')
      this.end_date = moment().utc().format('jYYYY/jMM/jDD')

      this.get_report(0)
    },
    methods: {
      open_context_menu (item) {
        var self = this
        var click_event = event
        this.clicked_request_context = item
        setTimeout(function () {
          self.$refs.menu.open(click_event, null)
        }, 150)
      },
      context_menu_clicked (func) {
        if (func == 'payments') {
          this.$router.push({ path:'/report-request/add-price-result/' + this.clicked_request_context.RecId })
        }
      },
      get_request_address (item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' '
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' '
        }
        if (item.AddressText != null) {
          address += item.AddressText + ' '
        }
        return address
      },
      goToDetail (item_id) {
        this.$router.push({ name: 'groups', params: {} })
      },
      get_report (page) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
          FirstDate: this.start_date,
          SecondDate: this.end_date,
          Page: page,

        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProductRequestReferRptByUserId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.user_registered = true;
              // self.fullName = response.data.msg;
              // self.level = 2;
             if(response.data.Items.length>0){
               if (page == 0) {
                 self.request_items = response.data.Items
               } else {
                 response.data.Items.forEach(function (number) {
                   self.request_items.push(number)
                 })
               }
               self.get_report(page+1)
             }else{
               self.request_items_filtered = self.request_items;
             }

            } else {
              self.not_register = true
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
